import { Paragraph } from '../Paragraph/Paragraph';
import Triangle from '../Triangle/Triangle';
import styled from 'styled-components';
import Carousel from '../Carousel/Carousel';
import { useTranslation } from 'react-i18next';
import TestimonialCard, { Testimonial } from './components/TestimonialCard/TestimonialCard';

const Opinions = () => {
  const { t } = useTranslation();
  const title = t('landing.opinions.title');
  const testimonials = t('landing.opinions.testimonials', {
    returnObjects: true,
  }) as Testimonial[];

  return (
    <>
      <Background>
        <Triangle color='#CEDDFF' />
        <ContentContainer>
          <TextBlock>
            <BigParagraph text={title} />
          </TextBlock>
          <CarouselContainer>
            <Carousel
              gap={10}
              ariaLabel='Testimonios de clientes'
              // overlayArrows
              slidesToShow={{ base: 1, sm: 2, lg: 3 }}
              navButtonLeftId='testimonials_carousel_navbutton_left'
              navButtonRightId='testimonials_carousel_navbutton_right'
            >
              {testimonials.map((testimonial, index) => (
                <TestimonialCard key={`${testimonial.name}-${index}`} data={testimonial} />
              ))}
            </Carousel>
          </CarouselContainer>
        </ContentContainer>
        <Triangle orientation='bottom' color='#CEDDFF' position='right' />
      </Background>
    </>
  );
};

export default Opinions;

const TextBlock = styled.div`
  padding: 0 1rem;
`;

const Background = styled.div`
  width: 100%;
  background-color: #ceddff;
  padding: 1rem 1rem 4rem 1rem;
  position: relative;
  margin-top: 120px;

  @media (min-width: 500px) {
    padding-bottom: 120px;
  }

  @media (min-width: 650px) {
    padding-bottom: 180px;
  }

  @media (min-width: 768px) {
    padding-bottom: 200px;
  }
`;

const ContentContainer = styled.div`
  max-width: 1300px;
  margin: 0 auto;
  width: 100%;
  padding: 45px 0;
  @media (min-width: 768px) {
    padding: 69px 0;
  }
`;

const CarouselContainer = styled.div`
  margin-top: 3rem;

  @media (min-width: 768px) {
    margin-top: 4rem;
  }
`;

const BigParagraph = styled(Paragraph)`
  font-size: 30px;
  line-height: 30px;
  text-align: center;

  @media (min-width: 768px) {
    font-size: 50px;
    line-height: 58px;
  }

  @media (min-width: 1024px) {
    font-size: 65px;
    line-height: 75px;
  }
`;
